import i18n from "@/i18n";
import {message as $message, Modal, notification} from "ant-design-vue";
import pinyin from 'js-pinyin'
import axios from "axios";
import {ExclamationCircleOutlined} from '@ant-design/icons-vue';
import {createVNode} from 'vue';
import dayjs from 'dayjs'
import {uuid} from 'vue-uuid';

var util = {
    aliicon: "//at.alicdn.com/t/font_2750484_niayxmhane9.js",
    casLoginUrl: "https://login.cibr.ac.cn/?service=",
    casOutUrl: "https://login.cibr.ac.cn/logout",
    localUrl: "https://genetic.cibr.ac.cn/",
    SUCCESS: "success",
    NOPERMISSIONS: "noPermission",
    animalTypeList() {
        return [
            {id: "small", name: i18n.global.t("smallMouse")},
            {id: "big", name: i18n.global.t("bigMouse")}
        ];
    },
    editTypeList() {
        return [
            {id: "01", name: i18n.global.t("knockOut")},
            {id: "02", name: i18n.global.t("knockIn")},
            {id: "03", name: i18n.global.t("pointMutation")},
            {id: "04", name: i18n.global.t("conditionalKnockout")},
            {id: "05", name: i18n.global.t("spotInsert")},
            {id: "06", name: i18n.global.t("randomInsert")},
            {id: "07", name: i18n.global.t("other")},
        ]
    },
    statusList(){
      return[
          {id: "00", name: i18n.global.t("makeApply")},
          {id: "01", name: i18n.global.t("produceProgrammes")},
          {id: "02", name: i18n.global.t("molecularCloning")},
          {id: "03", name: i18n.global.t("microinjection")},
          {id: "04", name: i18n.global.t("f0mice")},
          {id: "05", name: i18n.global.t("f1mice")},
          {id: "06", name: i18n.global.t("ArrangeTransfer")},
          {id: "07", name: i18n.global.t("ConfirmCompletion")},
          {id: "08", name: i18n.global.t("hasComplete")},
          {id: "98", name: i18n.global.t("quit")},
      ]
    },
    getUUID() {
        return uuid.v4();
    },
    $post(url, data, success, show, hide) {
        if (show !== null && show !== undefined) {
            show();
        }
        axios.post(url, data).then(function (res) {
            if (res.data.code === util.SUCCESS) {
                success(res.data.retMap);
            } else {
                util.error(res.data.code);
            }
        }).catch(function (res) {
            util.catchErr(res);
        }).finally(function () {
            if (hide !== null && hide !== undefined) {
                hide();
            }
        })
    },
    $confirm(config) {
        config.icon = createVNode(ExclamationCircleOutlined)
        Modal.confirm(config);
    },
    catchErr: function (res) {
        console.log(res);
        this.error("err.systemErr");
    },
    submitSuccess: function () {
        $message.success(i18n.global.t("commitSuccess"));
    },
    success: function (message) {
        $message.success(i18n.global.t(message));
    },
    error: function (message) {
        $message.error(i18n.global.t(message));
    },
    isNull: function (obj) {
        if (obj == null) {
            return true;
        }
        if (obj == undefined) {
            return true;
        }
        if (obj === "") {
            return true
        }
        if (obj.length == 0) {
            return true;
        }
        return false;
    },
    convertToPy: function (val) {
        return pinyin.getFullChars(val);
    },
    sorter: function (a, b) {
        if (a == undefined) {
            return 1;
        }
        if (b == undefined) {
            return -1
        }
        var index = 0;
        a = this.convertToPy(a);
        b = this.convertToPy(b);
        while (index < a.length && index < b.length) {
            var chara = a.codePointAt(index);
            var charb = b.codePointAt(index);
            if (chara == charb) {
                index++;
                continue;
            } else {
                return chara - charb;
            }
        }
        if (chara === undefined) {
            return 1
        }
        if (charb === undefined) {
            return -1
        }
        return chara.length - charb.length;
    },
    imageUrl(imageId) {
        return axios.defaults.baseURL + "/file/image/" + imageId;
    },
    filterOption: function (inputValue, option) {
        if (option.data.attrs.name.indexOf(inputValue) !== -1) {
            return true;
        } else {
            return false;
        }
    },
    notificationError(error, description = "") {
        notification.error({
            message: error,
            description: description,
            duration: 15
        })
    },
    getCommonUploadUrl: function () {
        return axios.defaults.baseURL + "/file/commonUpload"
    },
    dateFormat: function (daraStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
        if (this.isNull(daraStr)) {
            return "";
        }
        return dayjs(daraStr).format(pattern)
    },
    newMoment: function () {
        return dayjs();
    },
    commonDeleteFile: function (fileId, callBack = function () {
    }) {
        var post = {
            fileId: fileId
        }
        var that = this;
        axios.post("/file/delete", post).then(function (res) {
            if (res.data.code === that.SUCCESS) {
                that.success(i18n.global.t("deleteSuccess"));
                callBack();
            } else {
                that.error(res.data.code);
            }
        }).catch(function (res) {
            that.catchErr(res);
        });
    },
    commonDownload: function (fileId, fileName) {
        var post = {
            id: fileId
        }
        this.downLoad(post, "/file/download", fileName);
    },
    downLoad: function (postData, url, fileName) {
        axios({
            url: url,
            data: postData,
            method: 'post',
            responseType: 'blob'
        }).then(function (res) {
            console.log(res);
            let data = res.data;
            if (!data) {
                return
            }
            let url = window.URL.createObjectURL(new Blob([data]))
            let a = document.createElement('a')
            a.style.display = 'none'
            a.href = url
            a.setAttribute('download', fileName);
            document.body.appendChild(a)
            a.click() //执行下载
            window.URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
        })
    },
    uploadSuccess() {
        $message.success(i18n.global.t("uploadSuccess"));
    },
    uploadError() {
        $message.error(i18n.global.t("uploadError"));
    },
    deleteSuccess() {
        $message.success(i18n.global.t("deleteSuccess"));
    },
    download_txt(filename, text) {
        var pom = document.createElement('a');
        pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        pom.setAttribute('download', filename);
        if (document.createEvent) {
            var event = document.createEvent('MouseEvents');
            event.initEvent('click', true, true);
            pom.dispatchEvent(event);
        } else {
            pom.click();
        }
    }
}

export default util;